<template>
  <div>
    <v-container
      class="grey lighten-5"
      style="max-width: 80%; margin-top: 15%; border-radius: 8px"
    >
      <v-row no-gutters>
        <v-col cols="12" xs="12" style="margin: auto; text-align: center">
          <v-avatar size="200">
            <img
              style="width: 100%; height: auto"
              class="imgAvatar"
              :src="line.pictureUrl"
              @error="imageUrlAtl"
              alt="John"
            />
          </v-avatar>
        </v-col>
      </v-row>
      <v-row no-gutters>
        <v-col
          cols="12"
          xs="12"
          style="margin: auto; text-align: center; margin-top: 5px"
        >
          <p style="font-weight: bold; color: #0e3e26">
            {{ textHead }} {{ line.displayName }}
          </p>
        </v-col>
      </v-row>
    </v-container>
    <v-container
      class="grey lighten-5 otps"
      style="
        max-width: 80%;
        margin-top: 3%;
        padding: 0;
        border-radius: 8px;
        height: auto;
      "
    >
      <v-row no-gutters class="pt-3">
        <v-col cols="12">
          <label class="label2 pl-4">
            เบอร์โทรมือถือ
            <span style="color: grey; font-size: 12px">(MOBILE NUMBER)</span>
            <span style="color: red">*</span>
          </label>
          <div class="input-container2">
            <i class="fa fa-mobile-alt icon"></i>
            <v-text-field
              ref="mobile"
              v-model="value"
              type="number"
              v-mask="maskLength"
              placeholder="กรุณากรอกเบอร์มือถือ"
              outlined
              :rules="[rules.min]"
            ></v-text-field>
          </div>
        </v-col>
        <v-col cols="12">
          <label class="label2 pl-4">
            อีเมล
            <span style="color: grey; font-size: 12px">(EMAIL)</span>
            <span style="color: red">*</span>
          </label>
          <div class="input-container2">
            <i class="fa fa-envelope icon"></i>
            <v-text-field
              ref="email"
              v-model="email"
              type="email"
              placeholder="กรุณากรอกอีเมล"
              outlined
              :rules="[rules.emailRules]"
            ></v-text-field>
          </div>
        </v-col>
        <v-col cols="12">
          <label class="label2 pl-4">
            วันเกิด
            <span style="color: grey; font-size: 12px">(BIRTH DATE)</span>
            <!-- <span style="color:red;">*</span> -->
          </label>

          <div class="input-container2">
            <i class="fa fa-birthday-cake icon"></i>
            <v-menu
              ref="menu"
              v-model="menu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              full-width
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  ref="dob"
                  v-model="date"
                  readonly
                  v-on="on"
                  outlined
                  placeholder="กรุณาเลือกวันเกิด"
                ></v-text-field>
              </template>
              <v-date-picker
                ref="ddd"
                v-model="date"
                :max="new Date().toISOString().substr(0, 10)"
                min="1950-01-01"
                @change="save"
                placeholder="กรุณาเลือกวันเกิด"
              ></v-date-picker>
            </v-menu>
          </div>
        </v-col>
        <v-col cols="12">
          <label class="label2 pl-4">
            เพศ
            <span style="color: grey; font-size: 12px">(SEX)</span>
            <span style="color: red">*</span>
          </label>
          <v-radio-group
            v-model="radios"
            style="margin: auto; width: 90%"
            ref="gender"
            :rules="[rules.required]"
          >
            <v-radio label="ชาย (MALE)" value="male"></v-radio>
            <v-radio label="หญิง (FEMALE)" value="female"></v-radio>
            <v-radio label="ไม่ระบุ (OTHER)" value="other"></v-radio>
          </v-radio-group>
        </v-col>
        <v-col cols="1"></v-col>
        <v-col cols="10"><v-divider class="mt-3 mb-3" /></v-col>
        <v-col cols="1"></v-col>
        <v-col cols="12" class="pr-2 pl-2 d-inline-flex">
          <v-checkbox
            v-model="acceptTermAndCondition"
            :error="acceptTermAndConditionError"
            color="primary"
            dense
            hide-details
          />
          <div class="pt-1 mt-4 secondary--text">
            ฉันได้อ่านและยอมรับ
            <a @click="termDialog = true"> ข้อกำหนดการใช้งาน </a>
            และ<a @click="termDialog = true">นโยบายความเป็นส่วนตัว </a>
            <!-- ของซิซซ์เล่อร์ -->
          </div>
        </v-col>
        <!-- <v-col cols="12" class="pr-2 pl-2 pb-3 d-inline-flex">
          <v-checkbox
            v-model="acceptMarketingMessage"
            color="primary"
            dense
            hide-details
          />
          <div class="pt-1 mt-4 secondary--text">
            <span>
              ฉันยินยอมรับข้อมูลข่าวสาร กิจกรรมส่งเสริมการขายต่างๆ
              <a
                href="https://www.minor.com/en/affiliated-companies"
                target="_blank"
              >
              </a>
            </span>
            <span>
              โดยเราจะเก็บข้อมูลของท่านไว้เป็นความลับ
              สามารถศึกษาเงื่อนไข/ข้อตกลง
              <a @click="termDialog = true"> นโยบายความเป็นส่วนตัว </a>
              เพิ่มเติมได้ที่เว็บไซต์ของบริษัทฯ
            </span>
          </div>
        </v-col> -->
      </v-row>
    </v-container>
    <v-footer app class="font-weight-medium pa-0">
      <v-col class="text-center pa-0" cols="12">
        <v-btn
          tile
          block
          class="pa-3"
          height="60"
          color="primary"
          :disabled="isLoading"
          @click="register()"
        >
          <span class="title white--text">ยืนยันการสมัคร</span>
        </v-btn>
      </v-col>
    </v-footer>
    <!-- <v-container
      class="grey lighten-5 otps"
      style="
        max-width: 80%;
        margin-top: 3%;
        margin-bottom: 3%;
        padding: 0;
        border-radius: 8px;
        height: auto;
      "
    >
      <v-row no-gutters style="background-color: #0e3e26">
        <v-col cols="12" xs="12" style="margin: auto; text-align: center">
          <v-btn
            style="width: 100%;!important;background-color:#DD1F2D;color:white;"
            height="46px"
            color="primary"
            @click="register"
          >
            ยืนยันการสมัคร
          </v-btn>
        </v-col>
      </v-row>
    </v-container> -->
    <v-dialog
      v-model="termDialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card tile>
        <v-toolbar dark color="#0e3e26">
          <v-btn icon dark @click="termDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>
            ข้อกำหนดการใช้งาน และนโยบายความเป็นส่วนตัว
          </v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-card-text>
          <terms-and-conditions />
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="warningDialog">
      <v-card tile>
        <v-card-title class="headline"></v-card-title>
        <v-card-text>
          <span>
            คุณต้องตกลงยอมรับ <strong>ข้อกำหนดการใช้งาน</strong> และ
            <strong>นโยบายความเป็นส่วนตัว</strong>
          </span>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="#0e3e26" text @click="warningDialog = false">
            ตกลง
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import UserPlaceholder from "@/assets/user.svg";
import logo from "@/assets/Logo.png";
import regisServiec from "@/services/api/regis";
import { mask } from "vue-the-mask";

export default {
  name: "authentation",
  directives: {
    mask,
  },
  components: {
    // TermsAndConditions
  },
  data: () => ({
    logo: logo,
    maskLength: "##########",
    // mask: "###-###-####",
    showOtp: false,
    countExpireOtp: 60,
    max: 10,
    value: "",
    email: "",
    date: "",
    menu: false,
    modal: false,
    menu2: false,
    firstName: "",
    lastName: "",
    radios: "",
    justify: ["start", "center", "end", "space-around", "space-between"],
    imgLogo: null,
    imgProfile: null,
    opLine: [],
    formHasErrors: false,
    formHasErrors2: false,
    otpCheck: true,
    proSiz: false,
    show: true,
    showpage: true,
    showpage2: false,
    showpage3: false,
    showpage4: false,
    // line : this.$store.getters.getMember,
    otps: [
      { ref: "box-1", value: "", focus: true, read: false },
      { ref: "box-2", value: "", focus: false, read: true },
      { ref: "box-3", value: "", focus: false, read: true },
      { ref: "box-4", value: "", focus: false, read: true },
      { ref: "box-5", value: "", focus: false, read: true },
      { ref: "box-6", value: "", focus: false, read: true },
    ],
    rules: {
      required: (value) => !!value || "",
      min: (v) => v.length === 10 || "",
      emailRules: (v) =>
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/.test(
          v
        ) || "",
    },
    line: "",
    resultSizzler: null,
    textHead: "สวัสดีคุณ",
    textErr: "",

    acceptTermAndCondition: false,
    acceptMarketingMessage: false,
    acceptMarketingMessageError: false,
    acceptTermAndConditionError: false,
    termDialog: false,
    warningDialog: false,
    userPlaceholder: UserPlaceholder,
    checkCampaign: null,
  }),
  watch: {
    menu(val) {
      val && setTimeout(() => (this.$refs.ddd.activePicker = "YEAR"));
    },
    acceptTermAndCondition(val) {
      if (val) {
        if (this.acceptTermAndConditionError) {
          this.acceptTermAndConditionError = false;
        }
      }
    },
    acceptMarketingMessage(val) {
      if (val) {
        if (this.acceptMarketingMessageError) {
          this.acceptMarketingMessageError = false;
        }
      }
    },
  },
  async created() {
    this.imgLogo = logo;
    this.line = this.$store.getters.getMember;
    console.log("line", this.line);
    let rs = await regisServiec.findById(this.line.userId);

    if (rs) {
      //    console.log(rs)
      //     console.log(`${rs.birthYear}-${rs.birthMonth}-${rs.birthDay}`)
      this.value = rs.mobile;
      this.email = rs.email;
      this.radios = rs.gender;
      if (rs.birthYear && rs.birthMonth && rs.birthDay) {
        this.date = `${rs.birthYear}-${rs.birthMonth}-${rs.birthDay}`;
      }
      this.acceptTermAndCondition = rs.consent === "yes" ? true : false;
    }
  },
  computed: {
    formFirst() {
      return {
        mobile: this.value,
        email: this.email,
        line_user_id: this.opLine.userId,
      };
    },
    formSecound() {
      return {
        mobile: this.value,
        email: this.email,
        first_name: this.firstName,
        last_name: this.lastName,
        dob: this.date,
        gender: this.radios,
        line_user_id: this.line.userId,
        line_display_name: this.line.displayName,
        line_picture_url: this.line.pictureUrl,
        acceptTermAndCondition: this.acceptTermAndCondition,
        acceptMarketingMessage: this.acceptMarketingMessage,
      };
    },
  },
  methods: {
    save(date) {
      this.$refs.menu.save(date);
    },
    async countExpireOtpFn() {
      let _this = this;
      setTimeout(function () {
        _this.countExpireOtp--;
        if (_this.countExpireOtp > 0) {
          _this.countExpireOtpFn();
        }
      }, 1000);
      if (_this.countExpireOtp === 1) {
        _this.showOtp = true;
      }
    },
    imageUrlAtl(event) {
      event.target.src = this.userPlaceholder;
    },
    async register() {
      if (this.acceptTermAndCondition) {
        this.acceptTermAndConditionError = false;
        let handleError = true;
        for (let i in this.formSecound) {
          //   let item = this.formSecound[i];
          if (this.$refs[i]) {
            if (!this.$refs[i].validate()) {
              this.$refs[i].validate(true);
              handleError = false;
            }
          }
        }
        console.log(handleError);
        if (handleError) {
          this.showpage = true;
          this.showpage3 = false;
          console.log(this.formSecound);
          let day = "";
          let month = "";
          let year = "";
          if (this.formSecound.dob) {
            let temp = this.formSecound.dob.split("-");
            year = parseInt(temp[0]).toString();
            month = parseInt(temp[1]).toString();
            day = parseInt(temp[2]).toString();
          }
          let data = {
            lineId: this.formSecound.line_user_id,
            lineDisplayName: this.formSecound.line_display_name,
            imageUrl: this.formSecound.line_picture_url,
            mobile: this.formSecound.mobile,
            email: this.formSecound.email,
            birthDay: day,
            gender: this.formSecound.gender,
            birthMonth: month,
            birthYear: year,
            consent: this.formSecound.acceptTermAndCondition ? "yes" : "no",
          };
          //   console.log(data)

          let returnNextbest = await regisServiec.registerMember(data);
        //   console.log(returnNextbest);
          if (returnNextbest) {
            let checkOtp = await regisServiec.findOtp(data.lineId);
            if (checkOtp) {
              if (checkOtp.status) {
                this.$swal("สำเร็จ", "ยืนยัน Otp เรียบร้อยแล้ว", "success");
                window.location = `line://oaMessage/@835nlrok/?`
              } else {
                await regisServiec.createOtp(data.lineId);
                this.$router.push({ name: "otp" });
              }
            } else {
              await regisServiec.createOtp(data.lineId);
              this.$router.push({ name: "otp" });
            }
            // console.log(checkOtp);
            // this.$router.push({ name: "otp" });
          } else {
            this.$swal("ไม่สำเร็จ", "กรุณาลองใหม่อีกครั้ง", "error");
            this.showpage = false;
            this.showpage3 = true;
          }
        }
      } else {
        this.warningDialog = true;
        this.acceptTermAndConditionError = true;
      }
    },
  },
};
</script>

<style scope>
.title-new {
  font-size: 20px !important;
  font-weight: 500;
  line-height: 1 !important;
  letter-spacing: 0.02em !important;
}
.otps input {
  text-align: left;
}
.imgAvatar {
  border-radius: 50%;
}
body * {
  box-sizing: border-box;
}

.input-container {
  margin: auto;
  display: -ms-flexbox; /* IE10 */
  display: flex;
  width: 90%;
  margin-bottom: 15px;
  /* margin-top: 5%; */
}
.input-container2 {
  margin: auto;
  display: -ms-flexbox; /* IE10 */
  display: flex;
  width: 90%;
  margin-bottom: 15px;
  height: 40px;
  margin-top: 1%;
}

.icon {
  border: 1px solid #e0e0e0;
  padding: 10px;
  background: white;
  color: #495057;
  min-width: 50px;
  text-align: center;
  border-radius: 3px;
}

.input-field {
  width: 100%;
  padding: 10px;
  outline: none;
  border: 1px solid #e0e0e0;
}

.input-field:focus {
  border: 1px solid red;
}
.label {
  width: 90%;
  margin: auto;
  margin-top: 5%;
  color: #0e3e26;
}
.label2 {
  width: 90%;
  margin: auto;
  /* margin-top: 5%; */
  color: #0e3e26;
}
.v-text-field__slot input {
  color: black !important;
}
/* .v-input__slot {
  border: 1px solid white;
} */
.textOTP.v-input .v-input__slot {
  border: 1px solid white;
  background-color: #0e3e26 !important;
}
</style>
